import React, { useEffect, useState, useMemo, useRef } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import toast from 'react-hot-toast';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Loader from '../../components/loader';
import Button from '../../components/elements/button';
import { URLS } from '../../_config';
import Drawer from '../../components/Drawer';
import { Dropdown, Menu } from '../../components/Dropdown';
import Filters from '../../components/filters';
import { filterConfigType } from '../../_config/types';
import Icon from '../../components/icons';
import { titleCell } from '../../components/elements/function';
import { useDialog } from '../../store/api/hooks/dialogHook';
import { downloadExcel, downloadPDF, showLocalDateTime } from '../../_common/functions';
import { Link, useNavigate } from 'react-router-dom';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';
import CreateUserType from './_components/createUserType';
import UserSettingsForm from './_components/userSettingsForm';
import { useLocation } from "react-router-dom";
import { useUserSelector } from '../../store/selectors/userSelector';

ModuleRegistry.registerModules([AllCommunityModule]);

const UserSettings: React.FC = () => {
    const userApi = useUserApi();
    const commonApi = useCommonApi();
    const navigate = useNavigate();
    const location = useLocation();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setrowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [editData, setEditData] = useState<any>(null);

    const filtersRef: any = useRef();
    const createUserTypeRef: any = useRef();
    const userSettingsRef: any = useRef();
    const { confirm } = useDialog();
    const [selectedUserType, setSelectedUserType] = useState<any>(null);

    const filterConfig: filterConfigType[] = [
        { name: 'User Type Code', type: 'text', key: 'userTypeCode' },
        { name: 'User Type Name', type: 'text', key: 'userTypeName' },
    ]

    const searchParams = new URLSearchParams(location.search);
    const user:any = useUserSelector();
    const [isDevMode, setIsDevMode] = useState<boolean>(false);

    useEffect(() => {
        if(user.userTypeID == 1){
            setIsDevMode(true)
        }
    },[user]);


    const columnDefs = [
        {
            headerName: 'User Type',
            field: 'name',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 300, flex: 1,
            cellRenderer: titleCell
        },
        {
            headerName: 'Is Active',
            field: 'isActive',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 150,
            cellRenderer: (params: any) => {
                return (
                    <p className='hover:text-primary'>
                        {params.value ? 'Yes' : 'No'}
                    </p>
                );
            }
        },
        {
            headerName: 'Created at',
            field: 'addedDate',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 300, flex: 1,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary'>{showLocalDateTime(data.value)}</p>
                )
            }
        },
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 100,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        {params.data.userTypeID > 1 && <div>
                            <div className='flex items-center justify-center relative gap-3'>
                                <Icon
                                    name="settings"
                                    size={1.1}
                                    className="cursor-pointer text-primary hover:text-primary/80"
                                    title="User Settings"
                                    onClick={(e: any) => {
                                        /* e.stopPropagation();
                                        */
                                        setSelectedUserType(params.data);
                                        //setSelectedUserType(params.data.userTypeID)
                                        userSettingsRef.current.open();
                                    }}
                                />
                                {isDevMode &&<Link
                                    to={URLS.USER_TYPE_PERMISSION(params.data.userTypeID)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon
                                        name="managepermission"
                                        size={1.1}
                                        className="cursor-pointer text-primary hover:text-primary/80"
                                        title="Manage Permissions"
                                    />
                                </Link>}
                                {(!params.data.isSystemDefined && isDevMode) ? <div className='relative'>
                                    <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const dropdown: any = document.querySelector('.action-dropdown');
                                        if (dropdown) {
                                            dropdown.focus();
                                        }
                                        return false;
                                    }} />
                                    <select
                                        onChange={(e) => {
                                            handleActionChange(e, params);
                                            e.target.selectedIndex = -1;
                                        }}
                                        onFocus={(e) => {
                                            e.target.selectedIndex = -1;
                                        }
                                        }
                                        className="action-dropdown"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            opacity: 0,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <option value="edit">Edit</option>
                                        <option value="delete">Delete</option>
                                    </select>
                                </div> : <div className='relative w-[4px]'></div>}

                            </div>

                        </div>}
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                setEditData(rowData);
                createUserTypeRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete User Type',
                    message: 'Are you sure you want to delete this user type?',
                    onConfirm: () => {
                        userApi.deleteUserType({
                            userTypeID: rowData.userTypeID,
                        }, (data: any, msg: any) => {
                            toast.success(msg);
                            getUserTypes();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            /* case "permission":
                //window.location.href = `${URLS.USER_TYPE_PERMISSION(rowData.userTypeID)}`;
                navigate(URLS.USER_TYPE_PERMISSION(rowData.userTypeID));
                break; */

            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };


    const getUserTypes = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            search: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        userApi.getUserTypes(
            payload,
            (resp: any) => {
                console.log(resp);
                setrowData(resp.userTypeList ? resp.userTypeList : []);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                toast.error(error);
            }
        );
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };



    useEffect(() => {
        getUserTypes();
    }, []);

    return (
        <Layout>
            <Header title='User Type List' back="/users">
                <Header.Right>
                    {isDevMode && <Drawer isAfterOpenRender={true} _ref={createUserTypeRef} onClose={() => { setEditData(null); }}>
                        <Drawer.Button>
                            <Button>New User Type</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit User Type' : 'New User Type'} className='!w-[39rem]'>
                            <CreateUserType UserTypeID={editData?.userTypeID} onCreate={() => {
                                getUserTypes();
                                createUserTypeRef.current.close();
                                setEditData(null);
                            }} onCancel={() => {
                                setEditData(null);
                                createUserTypeRef.current.close();
                                getUserTypes();
                            }} />
                        </Drawer.Content>
                    </Drawer>}

                    <Drawer isAfterOpenRender={true} _ref={userSettingsRef} onClose={() => { setSelectedUserType(null); }}>
                        <Drawer.Button>
                        </Drawer.Button>
                        <Drawer.Content title={selectedUserType ? selectedUserType?.name : `User Settings`} className='!w-[45rem] !pr-1'>
                            <UserSettingsForm
                                userType={selectedUserType?.userTypeID}
                                onSave={() => {
                                    userSettingsRef.current.close();
                                    getUserTypes();
                                }}
                                onCancel={() => {
                                    setSelectedUserType(null);
                                    userSettingsRef.current.close();
                                }}
                            />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} /> */}
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='hidden gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                        Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                    </Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        setFiltersApplied({ generalFilter: false, locationFilter: false });
                        setCurrentPage(1);
                    }}>
                        Clear Filters
                    </p>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2 mt-3">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default UserSettings;